import { render, staticRenderFns } from "./pariCodice.html?vue&type=template&id=6456e4e2&"
import script from "./PariCodice.vue?vue&type=script&lang=js&"
export * from "./PariCodice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports